<template>
  <Dialog
    :model-value="visible"
    title="Cancel Appointment?"
    dialog-type="error"
    dialog-size="small"
    z-index="2100"
    :header-icon-src="deleteDialogIcon"
    :close-on-overlay="!loading"
    @update:model-value="(value) => { if (!value) handleClose() }"
    @close="handleClose"
  >
    <div class="py-6">
      <span data-testid="my-calendar.cancel-appointment-dialog.message-text" class="body-text">Are you sure you want to cancel this appointment? This action cannot be undone.</span>
      <div v-if="error" data-testid="my-calendar.cancel-appointment-dialog.error-text" class="mt-4 text-sm text-[#D10000]">{{ error }}</div>
    </div>

    <template #footer>
      <div class="flex justify-between items-center w-full">
        <ResponsiveButton
          data-testid="my-calendar.cancel-appointment-dialog.close-btn"
          button_type="outlined"
          built_in_theme="error"
          size="medium"
          display_name="Cancel"
          :disabled="loading"
          @click-button="emit('close')"
        />
        <ResponsiveButton
          data-testid="my-calendar.cancel-appointment-dialog.confirm-btn"
          button_type="filled"
          built_in_theme="error"
          size="medium"
          display_name="Cancel Appointment"
          :disabled="loading"
          @click-button="emit('confirm')"
        />
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import deleteDialogIcon from '@/assets/MyWorkBench/archive/delete.svg';

const emit = defineEmits(['close', 'confirm'])

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  error: {
    type: String,
    default: '',
  },
})

function handleClose() {
  if (props.loading) return;
  emit('close');
}
</script>

<style scoped>
.title {
  font-family: Inter;
  font-weight: 600;
  font-size: 20px;
  line-height: 100%;
  color: #D10000;
}

.body-text {
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 28px;
  letter-spacing: 0;
  color: #374957;
}
</style>
